/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// TODO: Fix accessibility

// Required imports and hooks added at the top without modifying existing code
import { FC, useEffect, useRef, useState } from 'react';
import { PlayCircleFill } from 'react-bootstrap-icons';
import { IMAGES_REPO } from '../../static-resources/home-image-repo';
import './video.component.scss';

interface VideoComponentProps {
  embedUrl: string;
  title: string;
  banner: string;
}

const VideoComponent: FC<VideoComponentProps> = ({
  embedUrl,
  title,
  banner,
}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const scrollTargetRef = useRef<HTMLDivElement>(null);

  const handlePlayVideo = () => {
    setIsPlaying(true);
  };

  // Scrolls to the placeholder div when the component mounts
  useEffect(() => {
    if (scrollTargetRef.current) {
      scrollTargetRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, []);

  // Effect to scroll into view each time `isPlaying` changes or `embedUrl` updates
  useEffect(() => {
    if ((isPlaying || embedUrl) && scrollTargetRef.current) {
      scrollTargetRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [isPlaying, embedUrl]);

  // Original component JSX structure starts here
  return (
    <div className="video-wrapper">
      {/* Placeholder div for scrolling reference */}
      <div ref={scrollTargetRef} />
      {!isPlaying ? (
        <div className="poster-image-container" onClick={handlePlayVideo}>
          <img
            src={banner || IMAGES_REPO.ReleaseNotes}
            alt="Click to play video"
            className="poster-image"
          />
          <PlayCircleFill className="play-button-overlay" />
          <div className="video-title">{title}</div>
        </div>
      ) : (
        <iframe
          src={embedUrl}
          width="640"
          height="360"
          scrolling="no"
          title={title}
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
        />
      )}
    </div>
  );
};

export default VideoComponent;
